import { startCase } from 'es-toolkit/compat';

export function getRegionFromEnum(regionEnumValue: string) {
  if (regionEnumValue === 'BayArea') {
    return 'SF Bay Area';
  }

  if (regionEnumValue === 'Dallas') {
    return 'Dallas / Fort Worth';
  }

  if (regionEnumValue === 'WashingtonDC') {
    return 'Washington DC';
  }

  return startCase(regionEnumValue);
}

/** A state plus whether any of its regions is active. */
type StateActiveStatus<Code extends string> = {
  state: Code;
  status?: typeof ACTIVE;
};

const ACTIVE = 'Active';

export function sortStatesByActiveStatus<Code extends string>(
  regionsByState: Record<Code, { status?: string }[] | undefined>,
): StateActiveStatus<Code>[] {
  const statesWithActiveRegions: StateActiveStatus<Code>[] = [];
  const statesWithoutActiveRegions: StateActiveStatus<Code>[] = [];

  const sortAlpha = (states: StateActiveStatus<Code>[]) =>
    states.sort((a, b) => a.state.localeCompare(b.state));

  // The same cast `useRegions` uses on its own `Object.keys` reads: the keys of
  // a `RegionByState` are state codes, which `Object.keys` widens to `string`.
  for (const state of Object.keys(regionsByState) as Code[]) {
    const regions = regionsByState[state];
    if (!regions) continue;
    const hasActiveRegions = regions.some((region) => region.status === ACTIVE);

    if (hasActiveRegions) {
      statesWithActiveRegions.push({ state, status: ACTIVE });
    } else {
      statesWithoutActiveRegions.push({ state });
    }
  }

  return [
    ...sortAlpha(statesWithActiveRegions),
    ...sortAlpha(statesWithoutActiveRegions),
  ];
}
